import { ICMVarAggregationMapType } from '../StateManagement'
import { MapLike } from '../core'
import { ValidBusinessObject, ValidBusinessObjectList, DatastoreObjectTypes, EdgeParams, HydrateableSkMappedItems } from '../datastoreProxy'

/** Wideawake API */
export type GetByTypeResponse = /*PaginatedInputResponse*/ StandardResponseMetaData & {
  Items: ValidBusinessObjectList
}

/** Wideawake API */
export type GetByTypeRequest = /*PaginatedInputRequest &*/ {}

/** Wideawake API */
export type GetItemsResponse = StandardResponseMetaData & {
  Items: ValidBusinessObjectList
}
/** Wideawake API */
export type GetItemsRequest = {
  Items: DatastoreObjectTypes
}

/** Wideawake API */
export type PutItemsRequest = {
  Items: ValidBusinessObjectList
}

/** Wideawake API */
export type PutItemsResponse = StandardResponseMetaData & {
  Items: ValidBusinessObjectList
}

/** Wideawake API */
export type GetItemResponse = StandardResponseMetaData & {
  Item: ValidBusinessObject | undefined
}

/** Wideawake API */
export type GetItemRequest = {
  Item: ValidBusinessObject
}

/** Wideawake API */
export type StandardResponseMetaData = {
  durationMs: number
}

/** Wideawake API */
export type PaginatedInputResponse = {
  LastEvaluatedKey: string | undefined
}

/** Wideawake API */
export type PaginatedInputRequest = {
  ExclusiveStartKey: string | undefined
  Limit: number | undefined
}

/** Wideawake API */
export type CustomerDevicesResponse = PaginatedInputResponse &
  StandardResponseMetaData & {
    Items: HydrateableSkMappedItems<ValidBusinessObject>
  }

/** Wideawake API */
export type CustomerDeviceRequest = PaginatedInputRequest & {
  MaxNodeEdgesCount: number
}

/** Wideawake API */
export type NetworkDataResponse = { itemsAdded: number; keysAdded: { sk: string; pk: string }[] } & StandardResponseMetaData

/** Wideawake API */
export type ServerInfoType = {
  totalRAMGB: number
  freeRAMGB: number
  arch: string
  uptimeSecs: number
  platform: NodeJS.Platform
  relase: string
  version: string
  homedir: string
  hostname: string
  storeSizeMB?: MapLike<number | undefined>
}

/** Wideawake API */
export type ServerInfoResponse = { serverInfo: ServerInfoType } & StandardResponseMetaData

/** Wideawake API */
export const isCustomerDeviceRequest = (parsedData: any): parsedData is CustomerDeviceRequest => {
  const request = parsedData as CustomerDeviceRequest
  return true
}

export type WideawakeGetAdjacentRequest = PaginatedInputRequest & {
  sourceNode: ValidBusinessObject
  edgeParams: EdgeParams
}

/** the plain object form as send to client */
export type WideawakeGetAdjacentWebResponse = PaginatedInputResponse &
  StandardResponseMetaData & {
    Items: HydrateableSkMappedItems<ValidBusinessObject>
  }

export type WidewakeAdditionalAttributes = {
  wideawakePersist?: number
  rate?: number
}

/** Wideawake API */
export type QueryByGraphPathRequest<T extends ValidBusinessObject> = {
  Items: T[]
  queryPath: EdgeParams[]
}
/** Wideawake API */
export type QueryByGraphPathResponse<T extends ValidBusinessObject> = {
  nodeEdgeMapper: HydrateableSkMappedItems<T>
}
/** Wideawake API */
export type RateBase = { rLast: number; tLast: number }
/** Wideawake API */
export type UTCBucketMeasures = {
  [s3TimeKey: string]: {
    cnt: number
    stats: ICMVarAggregationMapType
  }
}
/** Wideawake API */
export type ItemMetadata = { rateBase: RateBase; utcBuckets: UTCBucketMeasures }

/** Wideawake API */
export type MappedItemMetaData = { [pk: string]: { [sk: string]: ItemMetadata } }

/** Wideawake API */
export type GetItemMetadataResponse = StandardResponseMetaData & {
  itemMetadata: MappedItemMetaData
}
